import { useContent } from '@/lib/content-context'
import { Badge } from '@/ui'
import { useTranslation } from '@/i18n'
import { SHOW_APPRENTICESHIP } from '@/lib/feature-flags'

export function Highlights() {
  const { certifications, availability } = useContent()
  const { t } = useTranslation()

  return (
    <section className="py-8 bg-gray-50 border-y border-gray-200 dark:bg-gray-800 dark:border-gray-700">
      <div className="max-w-5xl mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Certifications */}
          <div>
            <h3 className="text-lg font-bold mb-3 dark:text-gray-100">
              {t('highlights.certifications')}
            </h3>
            <ul className="space-y-2 text-sm dark:text-gray-300">
              {certifications.map((cert, i) => (
                <li key={i} className="flex items-start gap-2">
                  <Badge variant="success" size="sm">
                    ✓
                  </Badge>
                  <span>
                    <strong>{cert.name}</strong> - {cert.issuer}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Availability — hidden when SHOW_APPRENTICESHIP is false */}
          {SHOW_APPRENTICESHIP && (
            <div>
              <h3 className="text-lg font-bold mb-3 dark:text-gray-100">
                {t('highlights.availability')}
              </h3>
              <div className="space-y-2 text-sm dark:text-gray-300">
                <p>
                  <strong>{t('about.targetRole')}</strong> {availability.target_role}
                </p>
                <p>
                  <strong>{t('about.startDate')}</strong> {availability.start_date}
                </p>
                <p>
                  <strong>{t('about.rhythm')}</strong> {availability.rhythm}
                </p>
                <p>
                  <strong>{t('about.school')}</strong> {availability.school}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
